module.exports = __webpack_public_path__ + "img/newDetail_szhzx6.5ff18f7c.png";